import { render, staticRenderFns } from "./MinimalSection.vue?vue&type=template&id=b0b51ef0&scoped=true&"
import script from "./MinimalSection.vue?vue&type=script&lang=js&"
export * from "./MinimalSection.vue?vue&type=script&lang=js&"
import style0 from "./MinimalSection.vue?vue&type=style&index=0&id=b0b51ef0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b51ef0",
  null
  
)

export default component.exports